import * as React from 'react';
import { DeleteForm } from '../DeleteForm';
import { useRevokeTokenForm } from './useRevokeTokenForm';

export const RevokeTokenForm = () => {
  const { revoke, inProgress } = useRevokeTokenForm();
  return (
    <DeleteForm
      onSubmit={revoke}
      inProgress={inProgress}
      headerText={'Biztos hogy visszavonja ezt a kulcsot? A folyamat nem visszafordítható!'}
      submitText={'Visszavonás'}
    />
  );
};
